// @ts-nocheck
import { Link } from 'react-router-dom';
import { Container, Stack, Grid, Group } from '@/components/ui/layout';
import { Card } from '@/components/ui/data-display';
import { Title, Text, Badge, Button } from '@/components/ui/core';
import { IconEye, IconArrowLeft } from '@tabler/icons-react';

const pages = [
  {
    name: 'Change Password',
    path: 'change-password',
    description: 'Allow users to change their current password securely',
    features: ['Current password', 'New password', 'Strength meter'],
  },
  {
    name: 'Email Verification',
    path: 'email-verification',
    description: 'Email verification success and pending states',
    features: ['Success state', 'Pending state', 'Resend option'],
  },
  {
    name: 'Account Locked',
    path: 'account-locked',
    description: 'Account locked notification with unlock options',
    features: ['Lock reason', 'Contact support', 'Unlock link'],
  },
  {
    name: '2FA Setup',
    path: 'two-factor-setup',
    description: 'Two-factor authentication setup wizard with QR code',
    features: ['QR code', 'Backup codes', 'App setup'],
  },
  {
    name: 'Logout',
    path: 'logout',
    description: 'Logout confirmation and success page',
    features: ['Confirmation', 'Session ended', 'Login link'],
  },
];

export default function OtherOverview() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        {/* Header */}
        <Group justify="space-between" align="flex-start">
          <div>
            <Button
              component={Link}
              to="/app/demo/auth-pages"
              variant="subtle"
              leftSection={<IconArrowLeft size={16} />}
              mb="sm"
            >
              Back to Overview
            </Button>
            <Title order={1}>Other Auth Pages</Title>
            <Text c="dimmed" size="lg" mt="xs">
              Additional authentication-related pages for complete user flows.
            </Text>
          </div>
          <Badge size="lg" color="pink">
            5 Pages
          </Badge>
        </Group>

        {/* Pages Grid */}
        <Grid gutter="lg">
          {pages.map((page) => (
            <Grid.Col key={page.name} span={{ base: 12, sm: 6, lg: 4 }}>
              <Card variant="elevated" p="lg" h="100%">
                <Stack gap="md" h="100%">
                  <div>
                    <Title order={3} mb="xs">{page.name}</Title>
                    <Text size="sm" c="dimmed" lineClamp={2}>
                      {page.description}
                    </Text>
                  </div>

                  <Group gap="xs" wrap="wrap" style={{ flex: 1 }}>
                    {page.features.map((feature) => (
                      <Badge key={feature} size="sm" variant="light" color="pink">
                        {feature}
                      </Badge>
                    ))}
                  </Group>

                  <Button
                    component={Link}
                    to={page.path}
                    variant="light"
                    color="pink"
                    fullWidth
                    rightSection={<IconEye size={16} />}
                  >
                    Preview
                  </Button>
                </Stack>
              </Card>
            </Grid.Col>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
}
